import cn from 'classnames';

export interface SegmentedControlItem<T extends string> {
  readonly value: T;
  readonly label: string;
}

interface SegmentedControlProps<T extends string> {
  readonly items: readonly SegmentedControlItem<T>[];
  readonly value: T;
  readonly onChange: (value: T) => void;
}

export default function SegmentedControl<T extends string>({
  items,
  value,
  onChange,
}: SegmentedControlProps<T>) {
  return (
    <div className='w-100 rounded-1 flex h-[40px] items-center justify-center rounded-fly-3 border border-[var(--slate-a3)]'>
      {items.map((item) => (
        <button
          key={item.value}
          data-testid={`home-tab-${item.value}`}
          onClick={() => onChange(item.value)}
          className={cn(
            { 'bg-slate-1': value === item.value },
            'text-slate-12 font-normal flex flex-1 cursor-pointer items-center justify-center self-stretch rounded-fly-3 px-fly-5 text-size-fly-3'
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
